import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import Button from '../Button';
import { dismissAction } from '../../redux/alert';
import SuccessIcon from '../Icons/Complete';
import Modal from '../Modal';
import getUniqueId from '../../utils/getUniqueId';
import styles from './Alert.css';

export const AlertBase = withRouter(({ alert, history, dismiss }) => {
    const [titleId] = useState(() => getUniqueId('alert-title'));
    const [messageId] = useState(() => getUniqueId('alert-message'));

    if (!alert) {
        return null;
    }

    let button = (<Button onClick={() => dismiss()} style={{ fontSize: '14px' }}>
        {alert.button || 'Close'}
    </Button>);

    if (alert.link) {
        button = (<Link to={alert.link}>
            {button}
        </Link>);
    }

    return (<Modal
        onClose={(event) => {
            dismiss();
            if (event.key === 'Enter' && alert.link) {
                history.push(alert.link);
            }
        }}
        className={cx(styles.alert, {
            [styles.prompt]: alert.type === 'prompt',
        })}
        open={!!alert}
        role="alertdialog"
        ariaLabelledBy={alert.title ? titleId : undefined}
        ariaDescribedBy={alert.message ? messageId : undefined}
    >
        { alert.build && (<img
            src="/img/icon_building.png"
            alt="App colors"
            style={{
                width: 95,
                height: 95,
                marginBottom: 10,
            }}
        />)}
        {alert.type === 'success' && !alert.build ? <SuccessIcon size={75} /> : null}
        <div role="status" aria-live="polite" aria-atomic="true">
            {alert.title && <h3 id={titleId}>{alert.title}</h3>}
            {alert.message && <p id={messageId}>{alert.message}</p>}
        </div>
        {button}
    </Modal>);
});

AlertBase.propTypes = {
    dismiss: PropTypes.func,
    alert: PropTypes.object,
    history: PropTypes.object,
};

AlertBase.defaultProps = {
    dismiss: () => null,
};

export default connect(({ alert }) => ({
    alert,
}), {
    dismiss: dismissAction,
})(AlertBase);



// WEBPACK FOOTER //
// ./src/client/Components/Alert/Alert.js